<template>
  <div id="adobe-dc-view" style="height: 80vh"></div>
</template>

<script>
export default {
  name: 'EsAttachmentPreviewPdf',
  props: {
    url: String,
    fileName: String,
    ADOBE_KEY: {
      type: String,
      required: true,
    },
  },
  mounted() {
    if (window.AdobeDC) this.createPDFView();
    else document.addEventListener("adobe_dc_view_sdk.ready",
      () => this.createPDFView());
  },
  methods: {
    createPDFView() {
      // eslint-disable-next-line no-undef
      var adobeDCView = new AdobeDC.View({
          clientId: this.ADOBE_KEY,
          divId: "adobe-dc-view"
      });
      adobeDCView.previewFile({
        content: {
          location: { url: this.url }
        },
        metaData: { fileName: this.fileName }
      }, {showAnnotationTools: false});
    },
  },
}
</script>